export default __webpack_public_path__ + "static/media/Osthammar.50014e58.svg";